<template>
  <div class="order-summary-list-item">
    <v-row class="ma-0 mb-2 pa-0">
      <v-col cols="12" md="4" class="ma-0 pa-0 label print-column"
        >{{ label }}:</v-col
      >
      <v-col cols="12" md="8" class="ma-0 pa-0 print-column">{{ value }}</v-col>
    </v-row>
    <v-divider class="mb-2" />
  </div>
</template>

<script>
export default {
  name: 'OrderSummaryListItem',
  components: {},
  props: ['label', 'value'],
  computed: {},
  methods: {},
};
</script>

<style scoped>
.label {
  color: rgba(0, 0, 0, 0.6);
}

@media print {
  .order-summary-list-item {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .print-column {
    display: inline-flex !important;
    width: auto !important;
    margin: 0 !important;
    flex: unset;
  }

  .label {
    width: 100px !important;
  }

  .row,
  .col,
  hr,
  .mb-2 {
    margin: 1pt !important;
  }

  div {
    font-size: 7pt !important;
    line-height: 7pt !important;
  }
}
</style>
